import { defineComponent, toRaw } from 'vue';
import { mapActions, mapGetters } from 'vuex';
export default defineComponent({
    name: 'filter-indikator-group',
    props: {
        filterType: {
            required: true,
            type: String,
        },
    },
    methods: Object.assign(Object.assign({}, mapActions('blue', {
        applyFilters: 'UPDATE_FILTERS',
    })), { clearFilter(numericValue) {
            const filters = structuredClone(toRaw(this.appliedFilters));
            let filterSet = filters[this.filterType];
            filterSet = filterSet.filter((filter) => filter.numericValue !== numericValue);
            filters[this.filterType] = filterSet;
            this.applyFilters(filters);
        } }),
    computed: Object.assign(Object.assign({}, mapGetters('blue', {
        availableFilters: 'availableFilters',
        appliedFilters: 'appliedFilters',
    })), { filterContent() {
            if (this.appliedFilters[this.filterType] === undefined) {
                return [];
            }
            return this.appliedFilters[this.filterType];
        },
        currentFilterItems() {
            const fullSet = structuredClone(toRaw(this.filterContent));
            fullSet.map((filter) => {
                filter.displayValue = this.availableFilters[this.filterType].find((availableFilter) => availableFilter.numericValue === filter.numericValue).displayValue;
            });
            return fullSet;
        } }),
});
